import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
} from "@angular/common/http";
import { FormGroup } from "@angular/forms";
import { environment } from "environments/environment.prod";
import { Observable } from "rxjs";
import { PastaArquivistica } from "./model/pasta/pasta.model";
import { EventEmitter, Injectable } from "@angular/core";
import { FormType } from "./components/import-matriz/import-matriz.component";
interface PontoDeAcesso {
  nodeId: number;
  idPontoDeAcesso: number;
  namePontoDeAcesso: string;
}
@Injectable()
export class ConfigurarPastaServiceService {
  apiURL = environment.API;
  private data:PontoDeAcesso[] = [];
  private dataVinculo:PontoDeAcesso[] = [];

  public isChangedNode: EventEmitter<void> = new EventEmitter();

  httpOptions = {
    headers: new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth")),
  };

  httpOptionsFile = {
    headers: new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth")),
  };

  constructor(private httpClient: HttpClient) {}

  setDataPontoDeAcesso(data: PontoDeAcesso[]) {
    this.data = data;
  }

  setDataPontoDeAcessoVinculo(data: PontoDeAcesso[]) {
    this.dataVinculo = data;
  }

  getDataPontoDeAcesso() {
    let temp = this.data;
    this.clearData();
    return temp;
  }

  getDataPontoDeAcessoVinculo() {
    let temp = this.dataVinculo;
    this.clearDataVinculo();
    return temp;
  }

  clearData() {
    this.data = [];
  }

  clearDataVinculo() {
    this.dataVinculo = [];
  }

  getPastasByIdCliente(
    idCliente: number
  ): Observable<Array<PastaArquivistica>> {
    return this.httpClient.get<Array<PastaArquivistica>>(
      this.apiURL + `/pasta/listar?idCliente=${idCliente}`,
      this.httpOptions
    );
  }

  salvarPastaArquivistica(form: FormGroup): Observable<PastaArquivistica> {
    return this.httpClient.post<PastaArquivistica>(
      this.apiURL + `/pasta-arquivistica/salvar`,
      form,
      this.httpOptions
    );
  }

  updatePastaArquivistica(obj): Observable<PastaArquivistica> {
    return this.httpClient.post<PastaArquivistica>(
      this.apiURL + `/pasta-arquivistica/update`,
      obj,
      this.httpOptions
    );
  }

  setAuthUsersByType(typesUsersToSave, clienteId): Observable<Array<any>> {
    const typesUsersJson = JSON.stringify(typesUsersToSave);

    return this.httpClient.post<Array<any>>(
      this.apiURL + `/set-auth-users-by-type/${clienteId}`,
      typesUsersJson,
      this.httpOptions
    );
  }

  getAuthUsersByClientAndNode(clientId, nodeId): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/get-users-by-node-and-client/${clientId}/${nodeId}`,
      this.httpOptions
    );
  }

  getNodesByClientAndUser(clientId, userId): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/get-nodes-by-client-and-user/${clientId}/${userId}`,
      this.httpOptions
    );
  }

  editUsersByNode(typesUsersToSave, clienteId, nodeId): Observable<Array<any>> {
    const typesUsersJson = JSON.stringify(typesUsersToSave);

    return this.httpClient.post<Array<any>>(
      this.apiURL + `/edit-users-by-node/${clienteId}/${nodeId}`,
      typesUsersJson,
      this.httpOptions
    );
  }

  editNodesByUser(typesUsersToSave, clienteId, userId): Observable<Array<any>> {
    const typesUsersJson = JSON.stringify(typesUsersToSave);

    return this.httpClient.post<Array<any>>(
      this.apiURL + `/edit-nodes-by-user/${clienteId}/${userId}`,
      typesUsersJson,
      this.httpOptions
    );
  }

  getTiposByCliente(idCliente: number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/tipo-alfresco/get-tipos-documentais/${idCliente}`,
      this.httpOptions
    );
  }

  getTiposByClienteArea(
    idCliente: number,
    idArea: number
  ): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL +
        `/tipo-alfresco/get-tipos-documentais-area/${idCliente}/${idArea}`,
      this.httpOptions
    );
  }

  getTiposByClienteAllArea(clienteId: number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL +
        `/tipo-alfresco/get-node-cliente-all-area?clienteId=${clienteId}`,
      this.httpOptions
    );
  }

  getNodeClienteArea(clienteId, areaId): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL +
        `/tipo-alfresco/get-node-cliente-area?clienteId=${clienteId}&areaId=${areaId}`,
      this.httpOptions
    );
  }

  getTiposNaoIncluidosByCliente(idCliente: number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/tipo-alfresco/nao-incluido?idCliente=${idCliente}`,
      this.httpOptions
    );
  }

  getTiposNaoIncluidosByClienteAndArea(idArea: number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/tipo-alfresco/nao-incluido-area?idArea=${idArea}`,
      this.httpOptions
    );
  }

  getAspectosNaoIncluido(idTipo: number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/tipo-alfresco/aspectos-nao-incluidos?idTipo=${idTipo}`,
      this.httpOptions
    );
  }

  salvarTiposDocumentais(form: FormGroup): Observable<Array<any>> {
    return this.httpClient.post<Array<any>>(
      this.apiURL + `/tipo-alfresco/vincular`,
      form,
      this.httpOptions
    );
  }

  salvarTiposDocumentaisArea(
    form: FormGroup,
    idArea: number
  ): Observable<Array<any>> {
    return this.httpClient.post<Array<any>>(
      this.apiURL + `/tipo-alfresco/vincular-area/${idArea}`,
      form,
      this.httpOptions
    );
  }

  salvarAspectos(form: FormGroup): Observable<Array<any>> {
    return this.httpClient.post<Array<any>>(
      this.apiURL + `/tipo-alfresco/vincular-aspecto`,
      form,
      this.httpOptions
    );
  }

  getURIsAlfresco(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/uri-alfresco/listar`,
      this.httpOptions
    );
  }

  salvarURIAlfresco(form: FormGroup): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + `/uri-alfresco/salvar`,
      form,
      this.httpOptions
    );
  }

  vincularURIAlfresco(form): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + `/uri-alfresco/vincular-uri`,
      form,
      this.httpOptions
    );
  }

  getAllTipos(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/uri-alfresco/listar-tipos`,
      this.httpOptions
    );
  }

  getAllTiposNotLinkedToClient(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/uri-alfresco/listar-tipos-not-linked`,
      this.httpOptions
    );
  }

  getAllAspectos(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/uri-alfresco/listar-aspectos`,
      this.httpOptions
    );
  }

  getAllAspectsNotLinkedToClient(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/uri-alfresco/listar-aspectos-not-linked`,
      this.httpOptions
    );
  }

  getModelosAlfresco(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/modelo-alfresco/listar`,
      this.httpOptions
    );
  }

  getModelosAlfrescoInterafece(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/modelo-alfresco/listar-modelos-interface`,
      this.httpOptions
    );
  }

  getDicionarioAutoria(): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/modelo-alfresco/listar/autoria`,
      this.httpOptions
    );
  }

  enviarModeloAlfresco(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append("file", file);

    const req = new HttpRequest(
      "POST",
      `${this.apiURL}/modelo-alfresco/upload`,
      formData,
      this.httpOptionsFile
    );

    return this.httpClient.request(req);
  }

  editProperty(propEdited): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + "/modelo-alfresco/edit-property",
      propEdited,
      this.httpOptions
    );
  }

  editNode(nodeEdited): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + "/node-dicionario/edit",
      nodeEdited,
      this.httpOptions
    );
  }

  getNomeTipo(id: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/get-nome-tipo/${id}`,
      this.httpOptions
    );
  }

  saveProperty(propriedade, tipoId): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + `/modelo-alfresco/save-property/${tipoId}`,
      propriedade,
      this.httpOptions
    );
  }

  deleteProperty(propId) {
    const headers = new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth"))
      .set("Content-Type", "application/json");
    return this.httpClient.delete(
      this.apiURL + `/modelo-alfresco/delete-property/${propId}`,
      { headers, responseType: "text" }
    );
  }

  getNodesByModelId(modelId: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/node-dicionario/get-nodes-by-model/${modelId}`,
      this.httpOptions
    );
  }

  createNewNode(newNode): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + "/node-dicionario/create-node",
      newNode,
      this.httpOptions
    );
  }

  createNewAspect(newAspect): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + "/node-dicionario/create-aspect",
      newAspect,
      this.httpOptions
    );
  }

  buscarPropertyByName(nome): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/modelo-alfresco/get-propriedade-by-name?nome=${nome}`,
      this.httpOptions
    );
  }

  postCriarModelo(form: FormGroup): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + `/modelo-alfresco/criar-modelo-novo`,
      form,
      this.httpOptions
    );
  }

  ativarDesativarModelo(id: number): Observable<any> {
    const headers = new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth"))
      .set("Content-Type", "application/json");
    return this.httpClient.get(
      this.apiURL + `/modelo-alfresco/ativar-desativar-modelo/${id}`,
      { headers }
    );
  }

  putModelo(form: FormGroup): Observable<any> {
    return this.httpClient.put<any>(
      this.apiURL + "/modelo-alfresco/editar-modelo",
      form,
      this.httpOptions
    );
  }

  getAspectByModelId(modelId: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/node-dicionario/get-aspect-by-model/${modelId}`,
      this.httpOptions
    );
  }

  deleteNode(nodeId: number): Observable<any> {
    return this.httpClient.delete<any>(
      this.apiURL + "/node-dicionario/delete/" + nodeId,
      this.httpOptions
    );
  }
  setPropInAspectAndAspectInType(body) {
    return this.httpClient.post(
      this.apiURL + `/set-prop-to-type`,
      body,
      this.httpOptions
    );
  }

  setPropInAspect(idAspect, idNode) {
    return this.httpClient.post(
      this.apiURL + `/set-prop-to-aspect-exist/${idAspect}/${idNode}`,
      null,
      this.httpOptions
    );
  }

  getModelByIdClient(idClient: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/modelo-alfresco/manter-aspectos/${idClient}`,
      this.httpOptions
    );
  }

  excluirAspect(aspect) {
    return this.httpClient.delete<any>(
      this.apiURL + `/node-dicionario/delet-aspect/${aspect}`,
      this.httpOptions
    );
  }

  sendMatrizFile(formValue: FormType, file): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append("file", file);
    formData.append("clientId", formValue.clientId.toString());
    formData.append("modelId", JSON.stringify(formValue.modelId));
    formData.append("modelPrefix", formValue.modelPrefix);
    formData.append("primaryTypeId", JSON.stringify(formValue.primaryTypeId));

    const req = new HttpRequest(
      "POST",
      `${this.apiURL}/matriz-avaliacao/upload`,
      formData,
      this.httpOptionsFile
    );

    return this.httpClient.request(req);
  }

  validateMatrizFile(formValue: FormType, file): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append("file", file);
    formData.append("modelPrefix", formValue.modelPrefix);
    formData.append("modelId", JSON.stringify(formValue.modelId));
    formData.append("clientId", formValue.clientId.toString());
    formData.append("primaryTypeId", JSON.stringify(formValue.primaryTypeId));

    const req = new HttpRequest(
      "POST",
      `${this.apiURL}/matriz-avaliacao/validate`,
      formData,
      this.httpOptionsFile
    );

    return this.httpClient.request(req);
  }

  buscarTabelaMatriz(clienteId: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/matriz/montar-tabela/${clienteId}`, this.httpOptions
    );
  }

  salvarAspcetoPropriedades(objectForm:any): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + `/matriz/criar-aspecto-propriedades`, objectForm, this.httpOptions
    );
  }

  vincularAspcetoPA(objectForm:any): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + `/matriz/vincular-aspecto`, objectForm, this.httpOptions
    );
  }

  vincularAspcetoNovaPropriedadePA(objectForm:any): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + `/matriz/vincular-aspecto-nova-propriedade`, objectForm, this.httpOptions
    );
  }

}



// WEBPACK FOOTER //
// /app/src/app/configurar-pasta-service.service.ts